import { render, staticRenderFns } from "./UserDashboardDeliveryCard.vue?vue&type=template&id=24a8a7ad&"
import script from "./UserDashboardDeliveryCard.vue?vue&type=script&lang=js&"
export * from "./UserDashboardDeliveryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VTooltip})
